// List of authorized email addresses that can access this portal
const allowedUsers = [
  'thofatechnologies@gmail.com',
  'thofatech321@gmail.com',
  'dev.thofatechnologies@gmail.com',
  // Add more email addresses here as needed
].map(email => email.toLowerCase()); // Convert all emails to lowercase for consistent comparison

export default allowedUsers; 